import { render, staticRenderFns } from "./KanbanView.vue?vue&type=template&id=0bb51e1a&scoped=true&"
import script from "./KanbanView.vue?vue&type=script&lang=js&"
export * from "./KanbanView.vue?vue&type=script&lang=js&"
import style0 from "./KanbanView.vue?vue&type=style&index=0&id=0bb51e1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb51e1a",
  null
  
)

export default component.exports